module.exports = __webpack_public_path__ + "img/lang.ca43fa6c.png";